{
  "enums": {
    "standard_category_type": {
      "food_and_beverage": "الأغذية والمشروبات",
      "cleaning": "النظافة",
      "operations": "العمليات",
      "it_hardware": "أجهزة تقنية المعلومات",
      "it_software": "برمجيات تقنية المعلومات",
      "maintenance": "الصيانة",
      "furniture": "الأثاث",
      "packaging": "التغليف",
      "uniforms": "الأزياء الموحدة",
      "marketing_and_print": "التسويق والطباعة",
      "medical_and_safety": "الطبية والسلامة",
      "professional_services": "الخدمات المهنية",
      "utilities": "المرافق",
      "logistics": "الخدمات اللوجستية",
      "other": "أخرى"
    }
  },
  "category": {
    "standardTypeField": "نوع المشتريات القياسي",
    "standardTypeHint": "النوع القياسي الذي تنتمي إليه هذه الفئة. قواعد الاعتماد التي توجّه الطلبات حسب النوع القياسي تستخدم النوع المحدد لهذه الفئة نفسها، فيبقى عملها سليماً حتى لو غيّرت اسم الفئة.",
    "standardTypeNone": "غير مرتبط",
    "standardTypeChoose": "اختر النوع القياسي",
    "standardTypeRequired": "يلزم الربط بنوع قياسي",
    "standardTypeRequiredError": "اختر نوع المشتريات القياسي. لا تكون الفئة نشطة إلا إذا كان لها نوع قياسي.",
    "standardTypeLegacy": "هذه الفئة نشطة بلا نوع قياسي. اختر نوعاً لحفظ تغييراتك."
  }
}
